@if ((messages$ | async) || []; as messages) {
  <app-notifications-header [enableMarkAll]="allMessagesSeen(messages)"
    (markAllAsRead)="markAllAsRead()"
    (close)="close()"
   />
  <app-loader #loader [loading]="loading" />
  @if (!loader.loading) {
    @if (messages.length) {
      @for (message of messages; track message) {
        <app-abstract-notification
          (click)="open(message)"
          [showBadge]="message.status === messageStatus.NEW"
        >
          <ng-container notification-icon>
            <i class="icon ni-mail color-gray"></i>
          </ng-container>
          <ng-container notification-title>{{ message.name }}</ng-container>
          <ng-container notification-text>{{ message.message }}</ng-container>
          <ng-container notification-subtext>
            {{message.time * 1000 | timeAgo | async }}
          </ng-container>
        </app-abstract-notification>
      }
    } @else {
      <div class="small color-gray p-4 text-center border-bottom">
        {{ 'NOTIFICATIONS.NO_DATA' | translate }}
      </div>
    }
  }
}
